var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0993 1.93851C19.3596 2.25734 18.5561 2.4869 17.7272 2.57618C18.5816 2.06604 19.232 1.26258 19.5381 0.30608C18.7474 0.777953 17.8547 1.12229 16.9237 1.30084C16.1712 0.49738 15.1 0 13.9139 0C11.6311 0 9.79457 1.84923 9.79457 4.11933C9.79457 4.43816 9.83283 4.757 9.8966 5.06308C6.4787 4.88453 3.43065 3.2521 1.40287 0.752448C1.04577 1.36461 0.841721 2.06604 0.841721 2.83124C0.841721 4.25962 1.56866 5.5222 2.6782 6.26189C2.00228 6.23639 1.36461 6.04509 0.816214 5.73901C0.816214 5.75176 0.816214 5.77727 0.816214 5.79002C0.816214 7.79229 2.23184 9.45023 4.11933 9.83283C3.77499 9.9221 3.40514 9.97312 3.0353 9.97312C2.76748 9.97312 2.51241 9.94761 2.25734 9.90935C2.78023 11.5418 4.29788 12.7278 6.10885 12.7661C4.69323 13.8756 2.92052 14.5261 0.994761 14.5261C0.650421 14.5261 0.331587 14.5133 0 14.475C1.82373 15.6484 3.9918 16.3243 6.32566 16.3243C13.9011 16.3243 18.046 10.0496 18.046 4.60396C18.046 4.42541 18.046 4.24686 18.0332 4.06832C18.8367 3.48166 19.5381 2.75472 20.0993 1.93851Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaTwitter);
export default __webpack_public_path__ + "static/media/fa-twitter.68f9e3d530662d3ac1f57024052f5a86.svg";
export { ForwardRef as ReactComponent };